export function esportRouteI18n(): string {
  return `esport`;
}
